module.exports = __webpack_public_path__ + "static/product_shot_travesia_mob-cd6251fce4a98d1ad598fdbbdec3cc8f.jpg";